<script lang="ts" setup>
	import type { PolicyResponse } from '~/types/Purchase'

	const props = defineProps<{
		metaDetails: PolicyResponse | null
		premium?: string
		isDeactivated: boolean
		isPending: boolean
		isExpired: boolean
	}>()

	defineEmits<{
		(event: 'activate'): void
		(event: 'reminder'): void
	}>()

	const downloadingHmo = shallowRef(false)
	const { calculateAge, formatDate } = useCustomDate()
	const statusMessage = computed(() => {
		const message = reactive({
			title: 'No Travel Detail',
			subTitle: 'This travel plan has not been activated yet. Activate now to enjoy full benefits.'
		})
		if (props.isDeactivated) {
			message.title = 'Travel Plan Deactivate'
			message.subTitle = 'This travel plan has been deactivated'
		}

		return message
	})
	const policy = computed(() => props.metaDetails as PolicyResponse)
	const age = computed(() => {
		if (policy.value?.date_of_birth) {
			return calculateAge(policy.value.date_of_birth).daysInLetter
		}
		return null
	})
	const policyDetails = computed(() => {
		const expiryDate =
			policy.value?.policy_expiration_date && formatDate(policy.value.policy_expiration_date, 'DD MMM, YYYY')
		return {
			'Policy number': policy.value?.meta?.policy_number || policy.value?.policy_number || '---',
			'Travel Date': policy.value?.meta?.start_date || policy.value?.meta?.departure_date,
			'Return Date': policy.value?.meta?.end_date || policy.value?.meta?.arrival_date,
			'Travel Destination': policy.value?.meta?.destination || '',
			Age: policy.value?.meta?.age || age.value || '',
			'Passport number': policy.value?.meta?.passport_number,
			'Travel Type': policy.value?.meta?.travel_type,
			'Purpose of Travel': policy.value?.meta?.travel_purpose,
			'Date Added': policy.value?.policy_start_date && formatDate(policy.value.policy_start_date, 'DD MMM, YYYY'),
			'Expiry Date': expiryDate,
			'Insurance Certificate': policy.value?.meta?.policy_certificate_url || policy.value?.policy_certificate_url
		}
	})
</script>

<template>
	<div>
		<!-- <my-cover-policy-status :is-pending="isPending" :is-active="!isExpired" :is-expired="isExpired" class="mb-4" /> -->
		<my-cover-pending-policy-placeholder
			icon-dir="documents"
			:title="statusMessage.title"
			:sub-title="statusMessage.subTitle"
			icon-name="clipboard-document-2"
			:is-pending="isPending || isDeactivated"
			activate-text="Activate Staff"
			:use-btn="!isDeactivated"
			@activate="$emit('activate')"
			@reminder="$emit('reminder')"
		>
			<template #button-group>
				<div></div>
			</template>
		</my-cover-pending-policy-placeholder>
		<my-cover-policy-card
			v-if="!isPending && !isDeactivated"
			:details="policyDetails"
			:downloading="downloadingHmo"
		>
			<template #value="{ record, dataIndex }">
				<template v-if="dataIndex === 'insurance_certificate'">
					<a
						:href="record as string"
						class="flex min-h-[44px] w-full items-center gap-x-3 rounded-md border border-gray-100 bg-gray-50 p-3 lowercase"
						download
						target="_blank"
					>
						<lazy-tools-icon dir="documents" icon="document-text" path-class="fill-gray-300" />
						<span>
							{{ record ? 'certficate.pdf' : '-------' }}
						</span>
					</a>
				</template>
			</template>
		</my-cover-policy-card>
	</div>
</template>
